import { Backdrop, Button, Grid, styled, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAddPertanyaan } from "../../../../api/effects/mutations/Pertanyaan/addPertanyaan";
import { useEditPertanyaan } from "../../../../api/effects/mutations/Pertanyaan/editPertanyaan";
import { useFetchPertanyaan } from "../../../../api/effects/mutations/Pertanyaan/useFetchPertanyaan";
import InputRadio from "../../../../components/InputRadio";
import InputSelect from "../../../../components/InputSelect";
import InputTextField from "../../../../components/InputTextField";
import RadioButton from "../../RadioButton";

const SquareGrid = styled(Grid)(({ theme }) => ({
  backgroundColor: "#FFF",
  height: "auto",
  boxShadow: "1px 1px 10px #888888",
  borderRadius: "10px",
  padding: "1%",
  width: "45%",
  [theme.breakpoints.down("md")]: {
    width: "60%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "90%",
    padding: "10px",
  },
  margin: "1%",
}));

const FullButton = styled(Button)(({ theme }) => ({
  marginTop: "3vh",
  marginBottom: "1vh",
  width: "60%",
}));

const ScrollGrid = styled(Grid)(({ theme }) => ({
  overflow: "auto",
  maxHeight: "90vh",
}));

type Props = {
  open: boolean;
  handleClose: () => void;
  ID?: number;
};

export default function PertanyaanModal({ ID = -1, open, handleClose }: Props) {
  const [pertanyaan, setPertanyaan] = useState("");
  const [tipePertanyaan, setTipePertanyaan] = useState("");
  const [isActive, setIsActive] = useState(false);

  const { mutateAsync: GetPertanyaanData } = useFetchPertanyaan({
    onSuccess(data) {
      setPertanyaan(data.PERTANYAAN);
      setTipePertanyaan(data.TIPE_PERTANYAAN);
      setIsActive(data.IS_ACTIVE);
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  useEffect(() => {
    if (ID > 0) {
      GetPertanyaanData(ID);
    } else {
      setPertanyaan("");
      setIsActive(false);
    }
  }, [open]);

  const handlePertanyaan = (e: any) => {
    setPertanyaan(e.target.value);
  };
  const handleTipePertanyaan = (e: any) => {
    setTipePertanyaan(e.target.value);
  };

 const handleIsActive = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsActive(e.target.value === "true");
  };

  const handleSave = () => {
    if (ID > 0) {
      EditPertanyaan({
        PERTANYAAN_ID: ID,
        PERTANYAAN: pertanyaan,
        TIPE_PERTANYAAN: tipePertanyaan,
        IS_ACTIVE: isActive,
      });
    } else {
      AddPertanyaan({
        PERTANYAAN: pertanyaan,
        TIPE_PERTANYAAN: tipePertanyaan,
        IS_ACTIVE: isActive,
      });
    }
  };

  const { mutateAsync: AddPertanyaan } = useAddPertanyaan({
    onSuccess() {
      handleClose();
      setPertanyaan("");
      setIsActive(false);
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  const { mutateAsync: EditPertanyaan } = useEditPertanyaan({
    onSuccess() {
      handleClose();
      console.log("Success");
    },
    onError() {
      console.log("Error");
    },
  });

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={open}
    >
      <SquareGrid container>
        <ScrollGrid container>
 <Grid container justifyContent="flex-start" paddingLeft={"10.5%"} item xs={6}
            paddingBottom={
              {
                xs: 5,
                sm: 5,
                md: 5,
                lg: 5,
                xl: 5
              }}>
            <Typography variant="subtitle1" color="black">
              {ID === -1 ? "Tambah Pertanyaan" : "Ubah Pertanyaan"}
            </Typography>
          </Grid>
          <Grid container justifyContent="flex-end" item xs={6}>
            <Button onClick={handleClose}>Close</Button>
          </Grid>
          <InputTextField
            title={"Pertanyaan"}
            value={pertanyaan}
            handleEdit={handlePertanyaan}
          />
          <InputSelect
            title={"Tipe Pertanyaan"}
            selection={[
              { value: "Essay", text: "Essay" },
              { value: "Essay Dengan Ya Tidak", text: "Essay Dengan Ya Tidak" },
            ]}
            value={tipePertanyaan}
            handleEdit={handleTipePertanyaan}
          />
          <RadioButton
            title="Active"
            value={isActive ? "true" : "false"}
            onChange={handleIsActive}
          />
          <Grid container justifyContent="center" item xs={12}>
            <FullButton variant="contained" onClick={handleSave}>
              Save
            </FullButton>
          </Grid>
        </ScrollGrid>
      </SquareGrid>
    </Backdrop>
  );
}
